// Une entrée checkout sans état React (retour d'une autre page ou bouton Suivant
// après « Modifier mon don ») ne doit pas devenir une étape fantôme.
let nextSkipAttempt = 0

export function skipStaleCheckoutEntry(history, campagneId, checkoutOpen, inFlight, previousState, schedule = setTimeout) {
    const stale = history.state?.cvCheckout === campagneId || history.state?.cvCheckoutSkipped === campagneId
    if (!campagneId || checkoutOpen || !stale) {
        inFlight.current = false
        return false
    }
    // StrictMode et plusieurs effets/popstate peuvent observer la même entrée avant
    // que history.back() ne change effectivement l'état.
    if (inFlight.current) return false
    inFlight.current = true
    const attempt = ++nextSkipAttempt
    if (previousState?.cvCheckoutBase === campagneId && history.state?.cvCheckoutHasSuccessor === true) {
        // Depuis la campagne, le donateur a avancé vers une ancienne entrée.
        // Suivre le même sens pour ne pas l'empêcher d'atteindre la page suivante.
        history.replaceState({...history.state, cvCheckout: null, cvCheckoutSkipped: campagneId, cvCheckoutSkipAttempt: attempt}, "")
        history.forward()
        // pagehide couvre aussi un simple rechargement et une navigation Next peut
        // être annulée : dans ces cas il n'existe aucune entrée suivante. Si aucun
        // popstate n'a quitté l'entrée sautée, revenir à la campagne.
        schedule(() => {
            if (inFlight.current && history.state?.cvCheckoutSkipped === campagneId &&
                history.state?.cvCheckoutSkipAttempt === attempt) history.back()
        }, 700)
    } else {
        // Depuis une autre page, ou sans entrée suivante, revenir à la campagne.
        // Changer le jeton invalide un éventuel repli d'une ancienne instance React.
        history.replaceState({...history.state, cvCheckoutSkipAttempt: attempt}, "")
        history.back()
    }
    return true
}

export function markCheckoutSuccessor(history, campagneId) {
    if (!campagneId || history.state?.cvCheckout !== campagneId) return false
    history.replaceState({...history.state, cvCheckoutHasSuccessor: true}, "")
    return true
}
